
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, QueryConfigurationInstitutions, QueryConfigurationInstitutionsResponse, ConfigurationInstitution } from "@/api/dtos";
import { useMemo } from "react";
import useGet from "@/hooks/api/useGet";

const getData = (response?: SWRResponse<QueryConfigurationInstitutionsResponse, QueryConfigurationInstitutionsResponse>) => response?.data?.data?.find(x => true);
const getError = (response?: SWRResponse<QueryConfigurationInstitutionsResponse, QueryConfigurationInstitutionsResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<QueryConfigurationInstitutionsResponse, QueryConfigurationInstitutionsResponse>) => ({});

export const useConfigurationInstitution = (query?: Partial<ConfigurationInstitution>, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new QueryConfigurationInstitutions(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useConfigurationInstitution;